// extracted by mini-css-extract-plugin
module.exports = {"auth-form-section":"LoginPage_auth-form-section__18v4d"};